import Globals from '../../../globals/index'
import { selectHasRole } from '../../../security/state/auth/selector'


export const enrichFinishedBy = (state, task) => {
    if (!task.finishedByUserId) {
        return
    }
    task.finishedByUserName = Globals.selector.selectUserDisplayNameById(state, task.finishedByUserId)
}

export const enrichCreatedBy = (state, task) => {
    task.objectDetail.customer.cbctFileList.forEach((file) => {
        file.createdByUser = Globals.selector.selectUserDisplayNameById(state, file.createdByUserId)
    })
}


export const enrichTransitionList = (state, task) => {
    const transitionList = task.processInstance.currentState.transitionList
    for (let index = 0; index < transitionList.length; index++) {
        const transition = transitionList[index]
        transition.isAllowedForUser = transition.requiredRoleList ? selectHasRole(state, transition.requiredRoleList) : true
    }
}


export const enrichTaskDetail = (state, task) => {
    enrichFinishedBy(state, task)
    enrichTransitionList(state, task)
    enrichCreatedBy(state, task)
}



// WEBPACK FOOTER //
// ./src/modules/process/state/task-detail/enrich-task-detail.js